const worksReact = [
  {
    title: 'Lunar Phase',
    accomplishment: ['Built with React & Node', 'Store data in Mysql', 'Shopping Cart'],
    img: 'React-LunarPhase-desktop.png',
    mobileImg: '',
    link: 'https://github.com/weichieh123/Lunar_Phase_React',
    tags: ['React', 'Node', 'MySql', 'Fetch'],
    rwd: false,
    content: '以React+Node實作電商網站(負責購物車、歷史訂單、收藏頁與團隊整合)。',
    isLong: true,
    isFlip: false,
  },
  {
    title: 'Food Order App',
    accomplishment: ['Built with React', 'Store data in Firebase', 'Management with useContext, useReducer'],
    img: 'React-FoodOrderApp-desktop.jpg',
    mobileImg: '',
    link: 'https://weichieh123.github.io/FoodOrderApp/',
    tags: ['React', 'useContext', 'useReducer', 'forwardRef', 'Firebase'],
    rwd: false,
    content: '使用React架構，實作電商網站點餐、結帳功能。',
    isLong: false,
    isFlip: false,
  },
  {
    title: 'E-Commerce',
    accomplishment: ['Built with React', 'Using Material UI', 'Using Commerce JS'],
    img: 'React-ECommerce-desktop.jpg',
    mobileImg: 'React-ECommerce-mobile.png',
    link: 'https://wei-react-ecommerce.netlify.app/',
    tags: ['React', 'Material UI', 'Commerce JS', 'Stripe'],
    rwd: false,
    content: '使用React架構，搭配Material UI、Commerce.js與Stripe，實現電商網站。',
    isLong: true,
    isFlip: false,
  },
  {
    title: 'Todo App',
    accomplishment: ['Built with React', 'Using Material UI', 'CRUD'],
    img: 'React-TodoApp-desktop.jpg',
    mobileImg: '',
    link: 'https://weichieh123.github.io/React-TodoApp-MUI/',
    tags: ['React', 'Material UI'],
    rwd: false,
    content:
      '使用React架構，搭配Material Design UI，實現Todo App。',
    isLong: true,
    isFlip: false,
  },
];

export default worksReact;
